import React, { useEffect, useState } from 'react';
import { Truck, CheckCircle, XCircle, Clock, X, AtSign, MessageSquare } from 'lucide-react';
import { useCurrency } from '../context/currencyContext';
import './ToastNotification.css';

const ToastNotification = ({ notification, onClose }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isLeaving, setIsLeaving] = useState(false);
  const { formatAmount } = useCurrency();

  useEffect(() => {
    setTimeout(() => setIsVisible(true), 10);

    const timer = setTimeout(() => {
      handleClose();
    }, 3000);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClose = () => {
    setIsLeaving(true);
    setIsVisible(false);
    setTimeout(() => {
      onClose();
    }, 300);
  };

  // ✅ SAFE: extract a display string from sender (object OR string)
  const getSenderDisplay = () => {
    const s = notification?.sender;
    if (!s) return 'Unknown';
    if (typeof s === 'string') return s;
    if (typeof s === 'object') {
      return (
        s.labName ||
        s.userName ||
        s.name ||
        s.title ||
        'Unknown'
      );
    }
    return 'Unknown';
  };

  const getIcon = () => {
    switch (notification?.type) {
      case 'outsource_request':
        return <Truck size={24} className="toast-icon" style={{ color: '#0d47a1' }} />;
      case 'outsource_accepted':
        return <CheckCircle size={24} className="toast-icon" style={{ color: '#28a745' }} />;
      case 'outsource_rejected':
        return <XCircle size={24} className="toast-icon" style={{ color: '#dc3545' }} />;
      case 'case_mention':
        return <AtSign size={24} className="toast-icon" style={{ color: '#0d6efd' }} />;
      case 'group_message':
        return <MessageSquare size={24} className="toast-icon" style={{ color: '#0dcaf0' }} />;
      default:
        return <Clock size={24} className="toast-icon" style={{ color: '#ffc107' }} />;
    }
  };

  // ✅ SAFE: notification may be null
  if (!notification) return null;

  return (
    <div
      className={`toast-notification-container ${isVisible ? 'visible' : ''} ${isLeaving ? 'leaving' : ''}`}
      onClick={handleClose}
      style={{ cursor: 'pointer' }}
    >
      <div className="toast-notification-content">
        <div className="toast-icon-wrapper">
          {getIcon()}
        </div>
        <div className="toast-body">
          <div className="toast-title">
            <strong>{notification.title || 'New Notification'}</strong>
            <button className="toast-close-btn" onClick={handleClose}>
              <X size={16} />
            </button>
          </div>
          <p className="toast-message">{notification.message}</p>
          {notification.data && (
            <div className="toast-details">
              {notification.data.caseNumber && (
                <span className="toast-badge">Case #{notification.data.caseNumber}</span>
              )}
              {notification.data.procedureName && (
                <span className="toast-badge toast-badge-secondary">{notification.data.procedureName}</span>
              )}
              {notification.data.price && (
                <span className="toast-badge toast-badge-success">
                  {formatAmount(notification.data.price)}
                </span>
              )}
            </div>
          )}
          <div className="toast-footer">
            <small className="toast-sender">
              From: {getSenderDisplay()}
            </small>
            <small className="toast-time">Just now</small>
          </div>
        </div>
      </div>
      <div className="toast-progress-bar">
        <div className="toast-progress-fill" />
      </div>
    </div>
  );
};

export default ToastNotification;